import ajaxFactory from './ajaxFactory';

const ajax = new ajaxFactory().create("public/wx/weixin");
export default ajax;
